import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Gruppo } from 'src/app/models/gruppo';
import { GruppoService } from 'src/app/services/gruppo.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { EditGruppoComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'gruppi',
  templateUrl: './gruppi.component.html',
  styleUrls: ['./gruppi.component.scss']
})
export class GruppiComponent implements OnInit {


  headingText: string = 'Gruppi';

  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Giorni automatismo scadenza',
        internalName: 'giorni_automatismo_scadenza',

      }
    ),
  ];
  constructor(public gruppoService: GruppoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<GruppiComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un gruppo';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (gruppo: Gruppo) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il gruppo ${gruppo.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.gruppoService.delete(gruppo);
          this.toast.success('Gruppo eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione gruppo fallita.", "Errore!");
    }
  }



  editFunction = async (gruppo: Gruppo) => {
    try {
      let dialogRef = this.dialog.open(EditGruppoComponent, { data: gruppo });
      dialogRef.afterClosed().subscribe(async (data: Gruppo) => {
        if (data) {

          Object.assign(gruppo, data);

          await this.gruppoService.edit(gruppo);

          this.toast.success('Gruppo modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica gruppo fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(EditGruppoComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(gruppo?: Gruppo) {
    if (gruppo) {
      try {
        await this.gruppoService.create(gruppo)
        this.toast.success('Gruppo creato!')
      }
      catch (e) {
        this.toast.error('Creazione gruppo fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
